// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../core/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-table {\n  width: 100%;\n}\n\n.info-table, .info-table td, .info-table th {\n  border-collapse: collapse;\n  border: 1px solid #cccccc;\n  color: #444444;\n  margin-top: 0.25rem;\n  padding-right: 0.5rem;\n  padding: 0.25rem;\n  text-align: left;\n  vertical-align: top;\n}\n\n.info-table-monospace {\n  font-family: Menlo, Monaco, \"Courier New\", monospace;\n  font-size: 0.88em;\n}\n", ""]);
// Exports
module.exports = exports;
